var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"day",class:{'active': _vm.active, 'disabled': _vm.disabled},attrs:{"role":"button"},domProps:{"innerHTML":_vm._s(_vm.$options.filters.toCalendarDay(_vm.day))},on:{"click":_vm.input}})}
var staticRenderFns = []

export { render, staticRenderFns }